//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';
import { useNavigate } from "react-router-dom";

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
} from '@mui/material';

// === COMPONENTS ===

//#endregion

//-----------------------------------------------------------------
export function RulesHeader() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme    = useTheme();
  const navigate = useNavigate();

  const _styles = {
    container: {
      display: 'flex',
      padding : '0.5rem' ,
      width   : '100%' ,
    },
    button_files: {

    }
  }

  const BUTTON_FILES = {
    sx: _styles.button_files,
    variant  : 'contained',
    onClick  : onClick,
    children: 'Files',
    name     : 'da_files_btn',
  }

  //#endregion

  //#region [EVENTS]

  function onClick( event ) {
    navigate( '/analytics/files', { replace: true } );
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container} >
        <Button {...BUTTON_FILES} />
      </Box>
    )
  }

  //#endregion

  return display();
}
